import { Component, OnInit, Output, EventEmitter} from '@angular/core';
import { GlobalService } from '../global.service';
import { HttpClient } from '@angular/common/http';
import * as M from "materialize-css/dist/js/materialize";
import * as $ from 'jquery';
import { VirtualTimeScheduler } from 'rxjs';

@Component({
	selector: 'pregled-vlasnika',
	templateUrl: './pregled-vlasnika.component.html',
	styleUrls: ['./pregled-vlasnika.component.css']
})
export class PregledVlasnikaComponent implements OnInit {
	@Output() onCancel = new EventEmitter<any>();
	loading : boolean = false; 
	currentView = 'main';
	novoPravnoLice : boolean = true; 
	odabranoPravnoLiceId : any = null;
	odabranoFizickoLiceId : any = null;
	prijave : any = [];
	odabraniVlasnikId : any = null;
	odabraniVlasnikNaziv : any = null;
	//old
	sortOption = 1; //dozvoljene vrijednosti su bodovi i vrijeme
	vrsteLica = [{id : 1, naziv : 'Pravno lice'}, {id : 0, naziv : 'Fizičko lice'}];
	vrstaLica : any = '1'; 
	nazivPretraga : any = null;
	pibPretraga : any = null;
	imePretraga : any = null;
	prezimePretraga : any = null;
	lica : any = [];

	constructor(public globalSrvc: GlobalService, public http : HttpClient) { }

	ngOnInit() {
		setTimeout(() => {
			/*var elems = document.querySelectorAll('.modal');
    		var instances = M.Modal.init(elems, {});*/
			M.updateTextFields();
		}, 1000);

		//this.ucitajStudProgram();	
	}

	vrstaLicaSelected(event){
		this.lica = [];
	}

	cancel(){
		if (this.onCancel)
			this.onCancel.emit(null);
	}

	pretraziPravnaLica(){
		this.loading = true; 
		setTimeout(() => {
			this.http.get(this.globalSrvc.rootUrl + 'vlasnici/pretraga/pravno', {params: {naziv : this.nazivPretraga?this.nazivPretraga:'', pib : this.pibPretraga?this.pibPretraga:''}})
			.subscribe(data => {
				this.lica = data;
				//console.log(data);
				this.loading = false;
			},
			error => {
				this.loading = false;
			});	
		}, 1000);
	}

	pretraziFizickaLica(){
		console.log(this.imePretraga, this.prezimePretraga);
		this.loading = true; 
		setTimeout(() => {
			this.http.get(this.globalSrvc.rootUrl + 'vlasnici/pretraga/fizicko', {params: {ime : this.imePretraga?this.imePretraga:'', prezime : this.prezimePretraga?this.prezimePretraga:''}})
			.subscribe(data => {
				this.lica = data;
				console.log(data);
				this.loading = false;
			},
			error => {
				this.loading = false;
			});	
		}, 1000);
	}

	logout(){
		this.globalSrvc.logout();
		this.globalSrvc.redirectToLogin();
	}

	result : any = null;

	dodajPravnoLice(){
		this.novoPravnoLice = true;
		this.odabranoPravnoLiceId = null;
		this.currentView = 'pravnolice';
	}

	izmijeniPLice(lice){
		this.novoPravnoLice = true;
		this.odabranoPravnoLiceId = lice.id;
		this.currentView = 'pravnolice';
	}

	dodajFizLice(){
		this.odabranoFizickoLiceId = null;
		this.currentView = 'fizickolice';
	}

	izmijeniFLice(lice){
		this.odabranoFizickoLiceId = lice.id;
		this.currentView = 'fizickolice';
	}

	onCancelChild(data){
		this.currentView = 'main';
	}

	onInsertPLice(obj){
		this.currentView = 'main';
		
		let ind = this.lica.findIndex((item) =>  item.id == obj.id);
		console.log('ind', ind);

		if (ind == -1)
			this.lica.unshift(obj);
		else {
			this.lica[ind] = obj;
		}
	}

	pregledAuto(vlasnik){
		this.odabraniVlasnikId = vlasnik.id;
		
		if (this.vrstaLica=='0')
			this.odabraniVlasnikNaziv = vlasnik.ime + " " + vlasnik.prezime; 
		else 
			this.odabraniVlasnikNaziv = vlasnik.naziv;

		this.currentView = 'pregledauto';
	}

	/*ponistiprijavu(prijava){
		this.prijavafakultetponisti = prijava; 
		this.currentView = 'main';
		var elem = document.getElementById('modal7');				
		var instance = M.Modal.init(elem, {onCloseEnd : () => {}});
		instance.open();
	}*/


	msg : any = null;

	ranglistaPDF(outType){
        //console.log(this.ucenik);
        this.loading = true;
        let url = 'getReport/ranglista';
        
        this.http.get(url, {params : {'nazivStudPrograma' : '', 'outType' : outType}, responseType: 'blob'})
        .subscribe(
         data => {            
            this.loading = false;
            this.globalSrvc.openBlob(data, outType);
         },
         error => {            
            this.loading = false;
            window.alert('Došlo je do greške prilikom generisanja rang liste');
        });    
    }

	openhelp(){
		
        let url = 'upustvo';
        this.http.get(url, {params : {}, responseType: 'blob'})
        .subscribe(
         data => {            
            this.loading = false;
            this.globalSrvc.openBlob(data, 'pdf');
         },
         error => {            
            this.loading = false;
            window.alert('Došlo je do greške prilikom fajla');
        });   
	}

	evidencija(){
		this.loading = true;
		let url = 'pregled/evidencija';

		this.http.get(url, { params: { 'godina': '2022' }, responseType: 'blob' })
			.subscribe(
				data => {
					this.loading = false;
					this.globalSrvc.openBlob(data, 'word');
				},
				error => {
					this.loading = false;
					window.alert('Došlo je do greške prilikom generisanja izvjestaja');
				});
	}
}
